import { MongoAbility, Subject } from "@casl/ability";

//#region Global types

/**
 * `manage` and `all` are special keywords in CASL.
 * manage represents any action and all represents any subject.
 * @link https://casl.js.org/v5/en/guide/intro
 */
type CASLKeywordTuple = ["manage", "all"];
export type ArchipadAbilityTuple =
    | CASLKeywordTuple
    | [
          keyof typeof Action,
          EntitySubjectType | PageSubjectType | InteractionSubjectType | SectionSubjectType | Subject,
      ];
export type ArchipadAbility = MongoAbility<ArchipadAbilityTuple>;

export enum AbilityGroupType {
    page = "page",
    entity = "entity",
    section = "section",
}

/**
 * Strongly inspired by CRUD actions
 * @link https://en.wikipedia.org/wiki/Create,_read,_update_and_delete
 */
export enum Action {
    /**
     * `manage` is a special keywords in CASL. manage represents any action.
     * @link https://casl.js.org/v5/en/guide/intro
     */
    manage = "manage",
    create = "create",
    read = "read",
    update = "update",
    delete = "delete",
    list = "list",
    download = "download",
    share = "share",
}

//#endregion

//#region Entity

export type EntitySubjectType =
    | `${AbilityGroupType.entity}_${keyof EntityTypeMap}`
    | EntityTypeMap[keyof EntityTypeMap];
//#endregion

//#region Page
export type PageTypeList =
    | "infos"
    | "plans"
    | "planning"
    | "meetings"
    | "issues"
    | "remarks"
    | "digitform"
    | "reports"
    | "dashboard"
    | "sav";
export type PageSubjectType = `${AbilityGroupType.page}_${PageTypeList}`;
//#endregion

//#region Section
export type SectionTypeList = `infos_building_program`;
export type SectionSubjectType = `${AbilityGroupType.section}_${SectionTypeList}`;
//#endregion

//#region Interaction
/**
 * Common interactions that are not linked to one or more entities or tabs
 */
export type InteractionTypeList = "report" | "document";
/**
 * We did not explicit the type of subject in this case
 */
export type InteractionSubjectType = InteractionTypeList;
//#endregion
